<app-dropdown
  [closeMethod]="closeMethod"
  [title]="'Showing ' + alertCount + ' alerts'"
  *ngIf="{ alertsLoading: alertsLoading$ | async } as data"
>
  <app-loading *ngIf="data.alertsLoading"></app-loading>
  <div *ngIf="!data.alertsLoading">
    <div class="alert">
      <div class="body" [class.no-alerts]="(alerts$ | async).length == 0">
        <ng-container *ngIf="{ alerts: alerts$ | async } as data">
          <ng-container *ngFor="let alert of data.alerts">
            <div
              class="single-alert"
              [class.expanded]="alert.expanded"
              [class.unread]="alert.status.title != 'Shown'"
            >
              <div class="alert-top-row">
                <div class="title">
                  <div
                    *ngIf="alert.status.title != 'Shown'"
                    class="unread-bubble"
                  ></div>
                  <div>{{ alert.title }}</div>
                </div>
                <div class="last-triggered">
                  {{
                    alertService.formatTimestampToNow(
                      alert.last_triggered_timestamp * 1000
                    )
                  }}
                </div>
                <div
                  class="see-more-holder"
                  (click)="toggleExpandAlert(alert.id)"
                >
                  <div>
                    {{
                      !alert.expanded
                        ? ("dropdown-alerts.button.show-more" | translate)
                        : ("dropdown-alerts.button.show-less" | translate)
                    }}
                  </div>
                  <div class="see-more-chevron">
                    <fa-icon
                      class="toggle-chevron"
                      [icon]="['fas', 'angle-down']"
                    ></fa-icon>
                  </div>
                </div>
              </div>
              <div class="alert-expandable" *ngIf="alert.expanded">
                <div class="expandable-group">
                  <div class="expandable-key">
                    <div>
                      {{ "dropdown-alerts.title.on-object" | translate }}
                    </div>
                  </div>
                  <div class="expandable-value">
                    <a
                      [href]="
                        'analytics/workspace/' +
                        alert.workspace_id +
                        '/feed/' +
                        alert['feed_id']
                      "
                      >{{ alert.feed_title }}</a
                    >
                  </div>
                </div>
                <div class="expandable-group">
                  <div class="expandable-key">
                    <div>
                      {{ "dropdown-alerts.title.triggered" | translate }}
                    </div>
                  </div>
                  <div class="expandable-value">
                    {{
                      alert.last_triggered_timestamp * 1000
                        | date: "dd.MM.yyyy HH:mm"
                    }}
                  </div>
                </div>
                <div class="expandable-group">
                  <div class="expandable-key">
                    <div>
                      {{ "dropdown-alerts.title.condition" | translate }}
                    </div>
                  </div>
                  <div class="expandable-value">
                    {{ alert.trigger_type.title }}
                  </div>
                </div>
                <div class="expandable-group">
                  <div class="expandable-key">
                    <div>
                      {{ "dropdown-alerts.title.created-on" | translate }}
                    </div>
                  </div>
                  <div class="expandable-value">
                    {{
                      alert.time_created.timestamp * 1000
                        | date: "dd.MM.yyyy HH:mm"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="no-alerts" *ngIf="(alerts$ | async).length == 0">
          {{ "dropdown-alerts.message.no-alerts" | translate }}
        </div>
      </div>
    </div>
  </div>
</app-dropdown>
